<template>
	<lyai-view-component :id="componentId" :theme="usedTheme" :icon="usedIcon" :title="alias" :type="activeViewType"
		:data="viewData" :settings="viewSettings" :textStyle="textStyle" :lineStyle="lineStyle">
		<template slot="search">
			<div class="nav navbar navbar-expand p-0" v-if="module">
				<ul class="navbar-nav scrollbar" style="overflow-x: scroll;" role="tablist">
					<template v-for="parent in conditions">
						<template v-for="condition in parent.conditions">
							<template v-if="condition.param">
								<li class="nav-item pl-1" :key="condition.id">
									<el-tag :type="theme">
										{{ value_label(module._embedded.resource.resourceType, module._embedded.resource.id, condition.field) }}
										{{ conditionOptions.filter(t => t.value === condition.condition )[0].label }}
										{{ !params[condition.param] ? condition.value : params[condition.param]}}
									</el-tag>
								</li>
							</template>
						</template>
					</template>
				</ul>
				<div v-if="!componentTotal || componentTotal==0" style="height: 16px;">
				</div>
				<el-popover placement="bottom" title="查询条件" width="400" trigger="click" v-if="componentTotal>0">
					<button slot="reference" class="btn btn-sidebar ml-1 float-right" href="#"><i class="fas fa-search"></i></button>
					<table class="table table-bordered">
						<tbody>
							<template v-for="parent in conditions">
								<template v-for="condition in parent.conditions">
									<template v-if="condition.param">
										<tr :key="condition.id">
											<td width="100px">{{ value_label(module._embedded.resource.resourceType, module._embedded.resource.id, condition.field) }}</td>
											<td class="p-0 m-0"
												style="height: 45px;background-color: blue;">
												<template v-if="value_type(module._embedded.resource.resourceType, module._embedded.resource.id, condition.field) === 'String'">
													<lyai-autocomplete style="height: 100%;" v-model="params[condition.param]" :resource="module._embedded.resource.id" :field="field(condition.field)" :placeholder="condition.value"></lyai-autocomplete>
												</template>
												<template v-else-if="['Long', 'BigDecimal'].includes(value_type(module._embedded.resource.resourceType, module._embedded.resource.id, condition.field))">
													<el-input-number v-model="params[condition.param]" clearable placeholder="查询"></el-input-number>
												</template>
												<template v-else-if="['OffsetDateTime'].includes(value_type(module._embedded.resource.resourceType, module._embedded.resource.id, condition.field))">
													<el-date-picker v-model="params[condition.param]" type="datetime" placeholder="查询" clearable></el-date-picker>
												</template>
												<template v-else>
													<el-input v-model="params[condition.param]" placeholder="查询" clearable></el-input>
												</template>
											</td>
										</tr>
									</template>
								</template>
							</template>
						</tbody>
					</table>
				</el-popover>
			</div>
		</template>
	</lyai-view-component>
</template>

<script>
	import {
		MODULE_ID_INIT,
		MODULE_ID_QUERY
	} from '@/api/api.generals.js'
	import {
		GET_ENTITY,
	} from '@/api/api.commons.js'
	import {
		mapGetters,
		mapActions,
	} from 'vuex'
	import LyaiAutocomplete from '@/views/analysis/components/LyaiAutocomplete.vue'
	
	export default {
		components: {
			LyaiAutocomplete
		},
		props: {
			entity: {
				type: Object,
				default () {
					return undefined
				}
			},
			id: {
				type: String,
				default () {
					return undefined
				}
			},
			theme: {
				type: String,
				default () {
					return 'default'
				}
			},
			icon: {
				type: String,
				default () {
					return 'fas fa-clock'
				}
			},

		},
		data() {
			return {
				activeViewType: 'count',
				alias: '标题',
				viewSettings: {},
				domain: '',
				businessTemplateId: '',
				viewData: {
					rows: [],
					columns: []
				},
				analysis: 'count',
				resourceType: 'resource',
				componentId: this.id,
				customIcon: undefined,
				customTheme: undefined,
				module: undefined,
				conditions: [],
				params: {},
				whereIndex: 0,
			}
		},
		created() {
			if (!this.entity && !this.id) {
				return;
			}
			new Promise((resolve) => {
				if (this.entity) {
					return resolve(this.entity)
				}
				GET_ENTITY({
					uri: `/generalViewComponents/${this.id}`,
				}).then(resolve)
			}).then((entity) => {
				let {
					activeViewType,
					alias,
					icon,
					theme,
					_links: {
						bookmark: {
							href: bookmark_uri
						}
					}
				} = entity
				this.componentId = entity.id
				this.activeViewType = activeViewType
				this.alias = alias
				this.customIcon = icon
				this.customTheme = theme
				bookmark_uri = bookmark_uri.substring(0, bookmark_uri.indexOf('{?'))
				GET_ENTITY({
					uri: bookmark_uri
				}).then((bookmark) => {
					const countModulePromise = new Promise((resolve, reject) => {
						return GET_ENTITY({ uri: bookmark._links.countModule.href }).then(module => {
							resolve({domain: 'countModules', module})
						}, reject)
					})
					const propertyModulePromise = new Promise((resolve, reject) => {
						return GET_ENTITY({ uri: bookmark._links.propertyModule.href }).then(module => {
							resolve({domain: 'propertyModules', module})
						}, reject)
					})
					const columnToRowModulePromise = new Promise((resolve, reject) => {
						return GET_ENTITY({ uri: bookmark._links.columnToRowModule.href }).then(module => {
							resolve({domain: 'columnToRowModules', module})
						}, reject)
					})
					
					Promise.any([
						countModulePromise,
						propertyModulePromise,
						columnToRowModulePromise,
					]).then(({domain, module}) => {
						this.module = module
						this.fetch_resource({id: module._embedded.resource.id})
						this.domain = domain
						this.businessTemplateId = module.id
						const settings = !module.settings ? undefined : JSON.parse(module.settings)
						this.conditions = []
						if (module.fieldGroups !== undefined) {
							this.setConditionsData(this.conditions, JSON.parse(module.fieldGroups).conditions)
						}
						MODULE_ID_INIT({
							domain: this.domain,
							id: this.businessTemplateId
						}).then(data => {
							this.viewSettings = settings[this.activeViewType] || data.supportedView[this.activeViewType].settings
							this.updateData()
						})
					})
				})
			})
		},
		computed: {
			...mapGetters('global/dashboard', [
				'textStyleColors',
			]),
			...mapGetters('global/resources', [
				'resources_labels', 'resources_y_props', 'resources_x_props', 'conditionOptions', 'field', 'to_field',
				'value_label', 'value_type',
			]),
			usedIcon() {
				return this.customIcon || this.icon
			},
			usedTheme() {
				return this.customTheme || this.theme
			},
			textStyle () {
				return {
					color: this.textStyleColors[this.usedTheme],//这里是改变字体颜色
					fontSize: 18//字体大小
				}
			},
			lineStyle() {
				return {
					color: this.textStyleColors[this.usedTheme],//这里是改变字体颜色
					width: 1,//线的大小
					type: "solid"//Y轴线的类型
				}
			},
			componentTotal() {
				let index = 0
				for (let parent of this.conditions) {
					for (let condition of parent.conditions) {
						index += !condition.param ? 0 : 1
					}
				}
				return index
			}
		},
		watch: {
			params: {
				handler() {
					this.updateData()
				},
				deep: true
			}
		},
		methods: {
			...mapActions('global/resources', [
				'fetch_resource'
			]),
			whereIndexPlus() {
				this.whereIndex += 1
				return this.whereIndex
			},
			getConditionsData(data, arr) {
				for (const item of data) {
					if (item.fieldGroupType !== undefined) {
						const parant = {
							fieldGroupType: item.fieldGroupType,
							conditions: []
						}
						this.getConditionsData(item.conditions, parant.conditions)
						arr.push(parant)
					} else {
						arr.push({
							field: this.field(item.field),
							condition: item.condition,
							value: item.value,
							param: item.param,
						})
					}
				}
			},
			setConditionsData(data, arr) {
				for (const item of arr) {
					if (item.fieldGroupType !== undefined) {
						const parant = {
							id: this.whereIndexPlus(),
							fieldGroupType: item.fieldGroupType,
							conditions: []
						}
						this.setConditionsData(parant.conditions, item.conditions)
						data.push(parant)
					} else {
						data.push({
							id: this.whereIndexPlus(),
							field: this.to_field(item.field),
							condition: item.condition,
							value: item.value,
							param: item.param,
						})
					}
				}
			},
			updateData() {
				MODULE_ID_QUERY({
					domain: this.domain,
					id: this.businessTemplateId,
					params: this.params
				}).then((data) => {
					this.viewData = data
				})
			},
		}
	}
</script>
